import { EnumModuloDTONecessitaFirma } from '@framework/api-client';
import {
  IFrontOfficeModule,
  ModuleStateProgressBar,
} from '@framework/frontoffice-submission';
import { useTranslation } from '@framework/i18n';
import { FlexRow } from '@framework/ui';
import { Divider } from 'antd';
import Title from 'antd/es/typography/Title';
import { darken, lighten } from 'polished';
import React from 'react';
import styled from 'styled-components';

const StyledinfoDivider = styled(Divider)`
  &&& {
    border-block-start: 1px solid
      ${props => lighten(0.2, props.theme.moduleDelegateColor)};
    opacity: 0.5;
  }
`;

const StyledTitle = styled(Title)`
  &&& {
    margin-bottom: 0;
    font-size: ${props => props.theme.fontSizeHeading5}px;
    font-size: 18px;
    color: ${props => darken(0.1, props.theme.moduleDelegateColor)};
  }
`;

const BoxWrapper = styled.div`
  padding: 24px;
  background-color: ${props => lighten(0.47, props.theme.moduleDelegateColor)};
  margin-bottom: 8px;
  border-radius: ${props => props.theme.borderRadius}px;
  border: 1px solid ${props => props.theme.moduleDelegateColor};
`;

export interface IModuleStateInfoBoxProps {
  module: IFrontOfficeModule | null | undefined;
  children?: React.ReactNode;
}

export function ModuleStateInfoBox(props: IModuleStateInfoBoxProps) {
  const { module } = props;
  const { t } = useTranslation();

  if (!module) return null;

  return (
    <BoxWrapper>
      <FlexRow
        right={
          <ModuleStateProgressBar
            currentState={module.stato}
            isValid={module.statoValidazione?.valido}
            hasSignatures={
              module.necessitaFirma !== EnumModuloDTONecessitaFirma.NO
            }
          />
        }
      >
        <StyledTitle level={3}>
          {t('submission-module.riepilogo-modulo', 'Riepilogo Modulo')}
        </StyledTitle>
      </FlexRow>
      <StyledinfoDivider />
      {props.children}
    </BoxWrapper>
  );
}
